"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

// Copyright 2017-2019 @polkadot/ui-keyring authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const subject = new _rxjs.BehaviorSubject(false);
var _default = {
  isDevelopment: () => subject.getValue(),
  set: isDevelopment => {
    subject.next(isDevelopment);
  },
  subject
};
exports.default = _default;